// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Gyh7H","value-wrapper":"styles_value-wrapper__eClCM","value":"styles_value__8v55o"};